import { jsx as t } from "react/jsx-runtime";
import D from "classnames";
import { forwardRef as b, useState as l, useRef as E, useImperativeHandle as F } from "react";
import u from "./index.es831.js";
import { v4 as P } from "uuid";
import { UtilityEyeHideIcon as S } from "./index.es440.js";
import { UtilityEyeIcon as T } from "./index.es441.js";
import { UnifiedInputField as h } from "./index.es62.js";
import { onKeyDownEnterAndSpace as g } from "./index.es526.js";
const m = "password-field", _ = `${m}-component`, N = b(
  ({
    value: i,
    testId: n = _,
    size: p = "default",
    id: f = `${m}-${P()}`,
    ...a
  }, w) => {
    const [s, I] = l(!0), [y, r] = l(!1), e = E(null), d = () => {
      I((o) => !o), setTimeout(() => {
        var o;
        (o = e.current) == null || o.focus();
      }, 100);
    };
    F(
      w,
      () => ({
        focus() {
          var o;
          (o = e == null ? void 0 : e.current) == null || o.focus();
        },
        ...e.current
      }),
      []
    );
    const c = i && y;
    return /* @__PURE__ */ t(
      h,
      {
        ...a,
        id: f,
        ref: e,
        testId: n,
        value: i,
        size: p,
        type: s ? "password" : "text",
        disableCloseIcon: !0,
        onFocus: () => r(!0),
        onBlur: () => setTimeout(() => r(!1), 20),
        "aria-label": a["aria-label"] || "Enter Password",
        RightIcon: /* @__PURE__ */ t(
          "button",
          {
            className: D(u.eyeIcon, {
              [u.hiddenEye]: !c
            }),
            onMouseDown: d,
            "data-testid": n + "-eye-icon",
            "aria-pressed": s,
            tabIndex: 0,
            "aria-hidden": !c,
            type: "button",
            "aria-label": `Toggle password visibility-${s ? "password visible" : "password hidden"}`,
            onFocus: () => setTimeout(() => r(!0), 200),
            onKeyDown: (o) => {
              g(o, d);
            },
            children: s ? /* @__PURE__ */ t(S, {}) : /* @__PURE__ */ t(T, {})
          }
        )
      }
    );
  }
);
export {
  _ as PASSWORD_FIELD_DEFAULT_TESTID,
  m as PASSWORD_FIELD_ID,
  N as PasswordField
};
//# sourceMappingURL=index.es47.js.map
